let paysList = {
    init() {

        var continentArray = [];
        $('.block-pays article').each(function(){
            var continent = $(this).attr('data-continent');
            continentArray.push(continent.split(' ')[0]);
        })


        var continentArray = continentArray.filter(function(elem, index, self) {
            return index === self.indexOf(elem);
        });

        for (let i = 0; i < continentArray.length; ++i) {
            var content = '<li id="'+continentArray[i]+'"><img src="/themes/arrow/dist/images/continents/'+continentArray[i]+'.svg" onload="SVGInject(this)" />'+continentArray[i]+'</li>';
            $(content).appendTo($('.block-pays .continent'));
        }




        $('.block-pays .continent li:first-child').addClass('active');
        var continentName = $('.block-pays .continent li:first-child').attr('id');
        $('.block-pays article[data-continent="'+continentName+'"]').each(function(){

            var paysName = $(this).attr('data-pays');
            var paysNameID = paysName.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');

            $(this).attr('id', paysNameID);
            $('<option class="'+paysNameID+'">'+paysName+'</option>').appendTo($('.block-pays .pays'));
        })
        var paysName = $('.block-pays .pays option').attr('class');
        $('.block-pays article#'+paysName).show(0);





        $('.block-pays .continent li').click(function(){
            $('.block-pays .continent li').removeClass('active');
            $(this).addClass('active');
            var continentName = $(this).attr('id');
            $('.block-pays .pays').empty();

            $('.block-pays article[data-continent="'+continentName+'"]').each(function(){
                var paysName = $(this).attr('data-pays');
                var paysNameID = paysName.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
                $(this).attr('id', paysNameID);
                $('<option class="'+paysNameID+'">'+paysName+'</option>').appendTo($('.block-pays .pays'));
            })

            $('.block-pays article').hide(0);
            $('.block-pays article[data-continent="'+continentName+'"]').first().show(0);
        })

        $('.block-pays .pays').change(function() {
            $('.block-pays article').hide(0);
            var paysName = $('option:selected', this).attr('class');
            $('.block-pays article#'+paysName).show(0);
        });

    }
}

export default paysList;
